import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  stroke: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 17"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.281 10.943a.265.265 0 1 1 0 .53.265.265 0 0 1 0-.53Z",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.281 8.021a3.188 3.188 0 0 1 3.188 3.188c0 1.36-1.904 3.95-2.77 5.056a.531.531 0 0 1-.836 0c-.865-1.107-2.77-3.696-2.77-5.056a3.188 3.188 0 0 1 3.188-3.188Z",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.092 16.314a7.972 7.972 0 1 1 6.212-9.435",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.58 16.236C5.502 14.655 4.78 11.782 4.78 8.5S5.501 2.346 6.58.764M.55 7.969h8.482M2.125 3.719h12.75M1.451 12.219H7.97M10.42.764a12.07 12.07 0 0 1 1.636 5.083",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }